<template>
    <div class="animated fadeIn paymentVoucherDetail bgV2">
        <b-row class="p-20 pr-4">
            <b-col md="12">
                <div class="d-flex headerComponent justify-content-between align-items-end">
                    <h3 class="title">{{pvItem ? pvItem.doc_no:''}}</h3>
                    <span class="status" v-if="pvItem">
                        <template v-if="total_approval_log > 0">
                            {{ `${pvItem.status}` }}
                        </template>
                        <template v-else>
                            {{ pvItem.status }}
                        </template>
                    </span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :variableWidth="true"
                        :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                            class="mr-3"
                            v-if="(pvItem.status === 'Under Approval' || pvItem.status !== 'Pending Revision' || modals.approval.approvalLogs.data.length) && pvItem.status !== 'Draft'"
                            @click="openModalApproval"
                            label="APPROVAL LOG" outline />
                        <gofix-button
                            :disabled="pvItem.total <= 0"
                            v-if="pvItem.status == 'Draft'"
                            :loading="loading"
                            @click="openStatusModal"
                            label="Next Action" outline />
                    </template>
                    <template slot="gofixTab:basic-info">
                        <pv-info @checkLineItemIsNull="checkLineItemIsNull"></pv-info>
                    </template>
                    <template slot="gofixTab:activity-log">
                        <pv-activities ref="pvActivities" activityType="Offset" :activityId="$route.params.offset_id"></pv-activities>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <!--Status-->
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Next Action" hide-footer :centered="true" v-model="modals.status.open">
            <b-form class="formInvoice pb-10">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="Next Possible Action"
                            v-model="modals.status.data.status"
                            :reduce="statusValue => statusValue.value"
                            :options="nextStatusData" />
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Remarks" class="mb-30 notFloat height-auto">
                            <b-form-textarea v-model="modals.status.data.activity_remark" rows="4"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="CANCEL" @click="modals.status.open = false" noBorder dark></gofix-button>
                <gofix-button label="OK" @click="updatePVStatus" :loading="modals.status.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!--Approval-->
        <b-modal
            :no-close-on-backdrop="true"
            modal-class="modals-approval gofixModal"
            size="lg"
            title="Approval"
            hide-footer
            :centered="true"
            ref="modal-approval-log"
            v-model="modals.approval.open">
            <!-- Action & Remarks -->
            <div class="actionAndRemarks modalPadding" v-bind:class="{'disabled-block':checkRoleApproval()}">
                <b-row>
                    <b-col md="12" class="mb-3" v-if="activeApprovalRoute && pvItem && (pvItem.status === 'Under Approval' || pvItem.status === 'Pending Revision' || pvItem.status === 'Draft')">
                        <gofix-text-field label="Next Approver" oneline>
                            <!--  && checkInRoleApproval() -->
                            <span v-if="pvItem.total < activeApprovalRoute.finance_limit">--</span>
                            <span v-else> {{modals.approval.approverNext.limit| formatMoney}} - {{modals.approval.approverNext.user}} </span>
                        </gofix-text-field>
                    </b-col>
                    <b-col md="12" class="mb-3" v-if="pvItem && (pvItem.status === 'Under Approval' || pvItem.status === 'Pending Revision' || pvItem.status === 'Draft')">
                        <gofix-text-field label="Current Approver" oneline>
                            <span v-if="pvItem.status === 'Draft'">--</span>
                            <span v-else>{{modals.approval.approverCurrent.limit| formatMoney}} - {{modals.approval.approverCurrent.user ? modals.approval.approverCurrent.user : ''}}</span>
                        </gofix-text-field>
                    </b-col>
                    <b-col md="9" class="">
                        <gofix-form-input-textarea label="remarks" class="mb-0 h-100" v-model="modals.approval.data.remark"></gofix-form-input-textarea>
                    </b-col>
                    <b-col md="3" class="action">
                        <gofix-button
                            class="d-block mb-2 w-100"
                            :label="pvItem.status === 'Pending Revision' ? 'Revision Applied':'Recommend for Approval'"
                            @click="approvalPV('Recommend for Approval')"
                            :disabled="checkRoleApproval() || (pvItem.status !== 'Draft' && activeApprovalRoute && (activeApprovalRoute.sequence == pvItem.approval_levels.length)) || modals.approval.loading"
                            v-if="activeApprovalRoute && (pvItem.total > activeApprovalRoute.finance_limit || (pvItem && (pvItem.status === 'Draft' || (pvItem.status === 'Pending Revision' && pvItem.approval_current_level < 0)) && !checkInRoleApproval()))"
                            outline />
                        <gofix-button
                            class="d-block mb-2 w-100"
                            label="Approve"
                            @click="approvalPV('Approval')"
                            v-if="activeApprovalRoute && pvItem.total <= activeApprovalRoute.finance_limit && checkInRoleApproval()"
                            :disabled="checkRoleApproval() || modals.approval.loading"
                            outline />
                        <gofix-button
                            class="d-block mb-2 w-100"
                            label="Request for Revision"
                            @click="approvalPV('Request for Revision')"
                            v-if="parseInt(pvItem.approval_current_level) >= 0 && pvItem.approval_current_level !== null && (pvItem.status === 'Under Approval' || pvItem.status === 'Pending Revision')"
                            :disabled="checkRoleApproval() || modals.approval.loading"
                            outline />
                        <gofix-button
                            class="d-block w-100"
                            label="Reject"
                            @click="approvalPV('Reject')"
                            :disabled="checkRoleApproval() || modals.approval.loading"
                            v-if="pvItem && (pvItem.status !== 'Draft' || (pvItem.status === 'Draft' && !checkRoleApproval())) && checkInRoleApproval()"
                            outline dark></gofix-button>
                        <gofix-button
                            class="d-block w-100"
                            label="Cancel"
                            @click="modals.approval.open = false"
                            v-if="pvItem && pvItem.status === 'Draft' && checkRoleApproval() || (pvItem.approval_current_level <= 0 && !checkInRoleApproval())"
                            outline dark />
                    </b-col>
                </b-row>
            </div>
            <hr/>
            <!--Table list logs v-if="ApprovalLogs.data.length"-->
            <b-row>
                <b-col md="12" class="mb-3">
                    <h5 class="modalTitle modalPadding">Approval Log</h5>
                </b-col>
                <b-col md="12">
                    <div class="gofixBasicTable approvalLogTable">
                        <div class="dataList">
                            <vue-scrollbar class="tableList">
                                <b-table :fields="modals.approval.approvalLogs.field" :items="modals.approval.approvalLogs.data" class="table-has-fixed" fixed>
                                    <template slot="finance_limit" slot-scope="row">
                                        {{ row.item.finance_limit | formatMoney}}
                                    </template>
                                    <template slot="log_time" slot-scope="row">
                                        {{ row.item.log_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                                    </template>
                                </b-table>
                            </vue-scrollbar>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    const pvInfo = () => import("./detail-info")
    const pvActivities = () => import("../../global/Activities")
    export default {
        name: 'offset_document-detail',
        components: {
            pvInfo,
            pvActivities,
        },
        data() {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                    {
                        key: "activity-log",
                        title: "Activity Log",
                        active: false
                    },
                ],
                loading: false,
                isDisableBtn: true,
                modals:{
                    status:{
                        open: false,
                        loading: false,
                        statusData:{
                            "Draft" : [
                                {value: "Under Approval", label: "Submit"},
                                {value: "Cancelled", label: "Cancel"}
                            ],
                            "Under Approval" : [
                                {value: "Approved", label: "Approve"},
                                {value: "Rejected", label: "Reject"}
                            ]
                        },
                        data:{
                            status:"",
                            activity_remark:"",
                        }
                    },
                    approval:{
                        open:false,
                        loading:false,
                        data:{
                            remark:null,
                            action: null,
                            approval_route_id: null,
                            offset_id: this.$route.params.offset_id
                        },
                        approvalLogs:{
                            data: [],
                            field:[
                                {
                                    key: 'approval_route_level',
                                    label: 'Route Lvl',
                                    thStyle: 'width: 100px'
                                },
                                {
                                    key: 'log_time',
                                    label: 'Time',
                                    thClass: 'text-center',
                                    tdClass: 'text-center'
                                },
                                {
                                    key: 'action',
                                    label: 'Action',
                                },
                                {
                                    key: 'reviewer.name',
                                    label: 'Reviewer',
                                },
                                {
                                    key: 'remark',
                                    label: 'Remarks',
                                },
                            ],
                            loading: false
                        },
                        approvalRoute:[],
                        approverNext: {
                            limit: 0,
                            user: null,
                            ids:[]
                        },
                        approverCurrent: {
                            limit: 0,
                            user: null,
                            ids:[]
                        }
                    }
                },
                total_approval_log: 0,
                timer: {
                    approval: null
                }
            }
        },
        watch: {
            pvItem: function(val) {
                // callback Contract selector
                if(val && val.client_contract_id && (!this.ClientContractID || !this.ClientContractID.id || (this.ClientContractID && this.ClientContractID.id && this.ClientContractID.id != val.client_contract_id))) {
                    this.$store.dispatch( 'ContractController/getClientContractID', val.client_contract_id).then(response => {
                        localStorage.setItem("ClientContractID", JSON.stringify(response.data.data));
                    })
                }
            }
        },
        computed: {
            nextStatusData(){
                if(!this.pvItem || !this.pvItem.status) return [];
                let status = this.modals.status.statusData[this.pvItem.status];
                if(this.pvItem.platform === 'LM'){
                  if(this.pvItem.status === 'Under Approval' || this.pvItem.status === 'Pending Revision'){
                    status = [{value: "Cancelled", label: "Cancel"}]
                  }
                }
                // platform
                return status;
            },
            activeApprovalRoute(){
                let current_index = (this.pvItem.approval_current_level && this.pvItem.approval_current_level >=0) ? this.pvItem.approval_current_level : 0;
                if(!this.pvItem.hasOwnProperty("approval_levels") || !this.pvItem.approval_levels.length) return [];
                return this.pvItem.approval_levels[current_index];
            },
            ...mapGetters({
                pvItem: "OffsetDocumentController/Item",
                UserLogged : 'AuthController/user',
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        async created() {
            this.getPV();
            this.getPvApprovalLogs();
            this.getNextApprover();
            this.getApprovalLogTableSetting();
        },
        methods: {
            /*------ Get data -----------------------------------*/
            getPV(){
                this.$store.dispatch('OffsetDocumentController/getPayment', this.$route.params.offset_id);
            },
            checkLineItemIsNull(key) {
                if( key === true ) this.isDisableBtn = true;
                else this.isDisableBtn = false;
            },
            getPvApprovalLogs(){
                let params = {
                    page: 1,
                    limit: -1,
                    filter:{
                        offset_id :  this.$route.params.offset_id
                    }
                }
                this.$store.dispatch('OffsetDocumentController/getApprovalLogs',params)
                    .then(response => {
                        this.modals.approval.approvalLogs.data = response.items;
                        this.total_approval_log = this.modals.approval.approvalLogs.data.length;
                    })
                    .catch(err => {
                        this.modals.approval.approvalLogs.data = [];
                        console.log(err)
                    })
            },
            getApprovalLogTableSetting(){
                this.$store.dispatch('AuthController/getNewColumnSettingsTableUser', {
                    user_id: 0,
                    table_name: "work-order-approval-log"
                }).then(response => {
                    this.modals.approval.approvalLogs.field = response.data.data.settings.fields
                }).catch(error => {})
            },
            async getNextApprover(){
                this.modals.status.loading = true;

                await this.$store.dispatch("OrderApprovalLogController/getNextApprover",{
                    offset_id: this.$route.params.offset_id,
                }).then(response => {
                    this.modals.approval.approverNext.user = response.next.user_name ? response.next.user_name.join(", ") : null;
                    this.modals.approval.approverNext.ids = response.next.user_ids;
                    this.modals.approval.approverNext.limit = response.next.finance;

                    this.modals.approval.approverCurrent.user = response.current.user_name ? response.current.user_name.join(", ") : null;
                    this.modals.approval.approverCurrent.ids = response.current.user_ids;
                    this.modals.approval.approverCurrent.limit = response.current.finance;

                    this.modals.status.loading = false;
                })
                .catch( err => {
                    this.modals.approval.approverNext.user = null;
                    this.modals.approval.approverNext.ids = [];
                    this.modals.approval.approverNext.limit = null;

                    this.modals.approval.approverCurrent.user = null;
                    this.modals.approval.approverCurrent.ids = [];
                    this.modals.approval.approverCurrent.limit = null;

                    this.modals.status.loading = false;
                })
            },

            /*------ Save Data ---------------------------------------*/
            async updatePVStatus(){
                if(!this.modals.status.data.status){
                    return this.$alertNotification("Please select a status", "danger");
                }
                if(this.modals.status.data.status === "Under Approval"){
                    await this.getNextApprover();
                    this.openModalApproval();
                    this.modals.status.open = false;
                    return
                }
                
                if(this.modals.status.loading) return;
                this.modals.status.loading = true;
                if(this.pvItem.status !== this.modals.status.data.status){
                    let params = Object.assign({id: this.pvItem.id},this.modals.status.data);
                    this.$store.dispatch(`OffsetDocumentController/updatePayment`, params)
                        .then(response => {
                            if(this.$refs.pvActivities) this.$refs.pvActivities.triggerReloadData();
                            this.modals.status.loading = false;
                            this.modals.status.open = false;
                            return this.$alertNotification(this.$notificationV2('editing', 'payment_voucher'));
                        })
                        .catch(err => {
                            console.log(err);
                            this.modals.status.loading = false;
                            return this.$alertNotification("Update failed", "danger");
                        })
                } else {
                    this.modals.status.loading = false;
                    this.modals.status.open = false;
                }
            },
            approvalPV(action){
                if (this.timer.approval) {
                    clearTimeout(this.timer.approval);
                    this.timer.approval = null;
                }
                this.timer.approval = setTimeout(async () => {
                    if(!this.activeApprovalRoute || this.modals.approval.loading) return;
                    this.modals.approval.data.action = action;
                    this.modals.approval.data.approval_route_id = this.activeApprovalRoute.id;
                    this.modals.approval.loading = true;
                    //createApprovalLogs
                    this.$store.dispatch(`OffsetDocumentController/createApprovalLogs`, this.modals.approval.data)
                        .then(async response => {
                            this.modals.approval.loading = false;
                            this.modals.approval.open = false;
                            await this.getPV();
                            await this.getPvApprovalLogs();
                            await this.getNextApprover();
                            if(this.$refs.pvActivities) this.$refs.pvActivities.triggerReloadData();
                            this.$alertNotification(this.$notificationV2('adding', 'approval'));
                        })
                        .catch(error => {
                            console.log(error)
                            this.modals.approval.loading = false;
                            let msg = `Can't "${action}"`;
                            if(error.response.data && error.response.data.error && error.response.data.error.message && error.response.data.error.message.error) {
                                msg = error.response.data.error.message.error;
                            }
                            this.$alertNotification(msg, "warning");
                        });
                }, 300);
            },

            /*----- Attribute -----------------------------------------*/
            openStatusModal(){
                if(!this.pvItem.approval_template_id) {
                    return this.$alertNotification("Offset doesn't have an approval template, so the approval process cannot be performed", "warning");
                }

                if(this.isDisableBtn && this.pvItem.status === 'Draft'){
                    return this.$alertNotification("Please add a offset line item to draft", "warning");
                }
                this.modals.status.data.status = this.pvItem.status;
                this.modals.status.data.activity_remark = null;
                this.modals.status.open = true;
            },
            checkRoleApproval(approval = false){
                if(!this.activeApprovalRoute || ((this.pvItem.status === "Draft" && this.modals.status.data.status === "Under Approval") || (this.pvItem.status === "Pending Revision" && this.pvItem.approval_current_level < 0))) return false;
                if(!this.activeApprovalRoute || (this.pvItem.status !== "Under Approval" && this.pvItem.status !== 'Pending Revision')) return true;
                if(this.checkInRoleApproval()){
                    return false;
                }
                return true;
            },
            openModalApproval(){
                if(!this.isDisableBtn){
                    this.modals.approval.data.remark = null
                    this.modals.approval.open = true
                }else{
                    this.$alertNotification("Please add a payment voucher line item to approval", "warning");
                }
            },
            checkInRoleApproval(){
                /*let userRoles = this.UserLogged.roles ? this.UserLogged.roles.map(a => a.id) : [];
                if(this.activeApprovalRoute && this.activeApprovalRoute.roles){
                    let roles     = this.activeApprovalRoute.roles.map(a => a.id);
                    const arrTmp  = userRoles.filter(item => roles.includes(item));
                    if(arrTmp.length) {
                        return true;
                    }
                }*/

                if(this.activeApprovalRoute && this.modals.approval.approverCurrent && this.modals.approval.approverCurrent.ids){
                    if(this.modals.approval.approverCurrent.ids.includes(this.UserLogged.id)) {
                        return true;
                    }
                }

                return false;
            },
        }
    }
</script>
